<div class="activity-attachments" [ngClass]="{'empty': !hasAttachments()}">
	@if (hasAttachments()) {
		<ngx-panel>
			<panel-heading>
				<span translate="activity-editor_activity-resources"></span>
			</panel-heading>
			<panel-body>
				@if (hasAttachments()) {
					<div class="attachments-grid">
						@for (attachment of activityFormService.getFormValue().attachments; let index = $index; track index) {
							<div class="attachment-card">
								<ngx-media-thumbnail
									class="attachment-thumbnail"
									[media]="attachment.media">
								</ngx-media-thumbnail>
								<div class="attachment-details">
									<div class="attachment-title">
										{{ getAttachmentTitle(attachment) }}
									</div>
									<ngx-toolbar>
										<ngx-toolbar-button
											[action]="toolbarActions.EDIT"
											(clicked)="editAttachment(attachment)">
										</ngx-toolbar-button>
										<ngx-toolbar-button
											[action]="toolbarActions.REMOVE"
											(clicked)="removeAttachment(attachment)">
										</ngx-toolbar-button>
									</ngx-toolbar>
								</div>
							</div>
						}
					</div>
				}
				<button
					type="button"
					class="link-btn add-btn"
					(click)="openAttachmentChooser()"
					translate="activity-attachments_add_resource">
				</button>
			</panel-body>
		</ngx-panel>
	} @else {
		<button
			type="button"
			class="link-btn add-btn"
			(click)="openAttachmentChooser()"
			translate="activity-attachments_add_resource">
		</button>
	}
</div>
